import type { Color, TextAlign, TextSize, Weight } from "@/types/ui/design";
import { alignClasses, fontClasses, sizeClasses } from "@/types/ui/design";
import type { JSX } from "react";
import React from "react";

type PennTextProps = {
  children: React.ReactNode;
  size?: TextSize;
  align?: TextAlign;
  color?: Color;
  font?: Weight;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
};

const PennText = ({
  children,
  size = "sm",
  color = "blue_grey",
  font = "normal",
  align="start",
  className = "",
  as: Component = "p",
}: PennTextProps) => {
    
  return (
    <Component
      className={`${sizeClasses[size]} ${fontClasses[font]}  ${alignClasses[align]}  ${className} ${`text-${color}`}`}
    >
      {children}
    </Component>
  );
};

export default PennText;